<template>
  <v-navigation-drawer
    :class="{'mobile-styles': isMobileDevice}"
    v-bind="drawerProps"
    :width="isMobileDevice ? '90%' : 220"
    :value="navbarShow"
    class="Navigation"
    fixed
    @input="stateNavbarShow"
  >
    <the-layout-navigation-list
      :routes="permissionRoutes"
      @toggle-nav-drawer="toggleNavDrawer"
    />

    <template #append>
      <v-list>
        <v-list-item
          v-ripple="false"
          :href="helpDeskUrl()"
          class="ml-n1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <v-list-item-icon class="Item">
            <v-icon dark>
              mdi-help-circle
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ $t("help") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>

// libs.
import { mapGetters } from 'vuex';

// components.
import TheLayoutNavigationList from './TheLayoutNavigationList.vue';

export default {
  name: 'TheLayoutNavigation',
  components: {
    TheLayoutNavigationList,
  },
  props: {
    showDrawer: { type: Boolean },
  },
  data: () => ({
    mainNavDrawerOpen: false,
    drawer: false,
  }),
  computed: {
    drawerProps() {
      let props = {};

      if (this.isMobileDevice) {
        props = { temporary: true };
      } else {
        props = {
          app: true,
          expandOnHover: true,
          miniVariant: !this.mainNavDrawerOpen,
          miniVariantWidth: 56,
          dark: true,
          permanent: true,
        };
      }
      return props;
    },
    ...mapGetters([
      'permissionRoutes',
      'navbarDense',
      'navbarShow',
      'navbarLogo',
      'toolbarDense',
      'user',
      'name',
    ]),
  },
  methods: {
    stateNavbarShow(state) {
      this.$emit('toggle-nav-drawer', state);
      this.$store.dispatch('NavbarState', { state });
    },
    toggleNavDrawer() {
      this.$emit('toggle-nav-drawer', false);
    },
    helpDeskUrl() {
      return 'https://yesters.zendesk.com/hc/et';
    },
  },
};
</script>

<style lang="scss" scoped>
.Navigation {
  background: $yester-lila;
}

//RESPONSIVENESS
.mobile-styles {
  &.Navigation {
    background: white;
    top: 0px;
    z-index: 80;
    border-right: none;
  }
}

.Item {
  background-color: $yester-lila-light;
  min-height: 32px;
  padding: 0;
  border-radius: 6px;
  min-width: 32px;
  width: 32px;
  height: 32px;
  margin: 10px 14px;
  margin-left: 0px !important;
  margin-right: 20px !important;

  .v-icon {
    min-width: 32px;
    width: 32px;
  }

  .v-list-item__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;

  }
}
</style>
